import Vuex from 'vuex' //引入状态管理
import Vue from 'vue'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    token: ''
  },
  mutations: {
    //写法与getters相类似
    //组件想要对于vuex 中的数据进行的处理
    //组件中采用this.$store.commit('方法名') 的方式调用，实现充分解耦
    //内部操作必须在此刻完成(同步)
    setToken (state, token) {
      localStorage.setItem("token", token);
      state.token = token;
    },
    removeToken (state, token) { // 退出登录
      localStorage.removeItem("token", token);
      state.token = token;
    },
  },
  getters : {
    //获取token方法
    //判断是否有token,如果没有重新赋值，返回给state的token
    getToken(state) {
      if (!state.token) {
        state.token = localStorage.getItem('token')
      }
      return state.token
    }
  },
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js